import React from "react";
import { Link } from "react-router-dom";
import FooterOne from "../Footer/FooterOne";
import Header from "../Header/HeaderTwo";
import { pageTitle } from "../PageTitle";

const Privacy = () => {
  pageTitle("Privacy");
  return (
    <>
      <Header></Header>
      <div className="services__details section-padding">
        <div className="container">
          <div className="row">
            <div className="col-xl-12 col-lg-8">
              <div className="services__details-left">
                <div
                  className="services__details-left-content mb-40"
                  style={{ paddingTop: "13%" }}
                >
                  {/* <h2 className="mb-30">Terms & Conditions</h2> */}
                  <div className="contact__area-title">
                    <span className="subtitle">Privacy Policy</span>
                  </div>
                  <p style={{ marginBottom: "1.5rem" }}>
                    Robert Brunhage built the Terms of service app app as a Free
                    app. This SERVICE is provided by Robert Brunhage at no cost
                    and is intended for use as is. This page is used to inform
                    visitors regarding my policies with the collection, use, and
                    disclosure of Personal Information if anyone decided to use
                    my Service. If you choose to use my Service, then you agree
                    to the collection and use of information in relation to this
                    policy. The Personal Information that I collect is used for
                    providing and improving the Service. I will not use or share
                    your information with anyone except as described in this
                    Privacy Policy. The terms used in this Privacy Policy have
                    the same meanings as in our Terms and Conditions, which is
                    accessible at Terms of service app unless otherwise defined
                    in this Privacy Policy.
                  </p>
                  <h4> Information Collection and Use</h4>
                  <p style={{ marginBottom: "1.5rem" }}>
                    For a better experience, while using our Service, I may
                    require you to provide us with certain personally
                    identifiable information. The information that I request
                    will be retained on your device and is not collected by me
                    in any way. The app does use third party services that may
                    collect information used to identify you. Link to privacy
                    policy of third party service providers used by the app
                    <br />-
                    <a href="https://policies.google.com/terms" target="_blank">
                      Google Play Services
                    </a>
                    <br />-
                    <a
                      href="https://firebase.google.com/terms/analytics"
                      target="_blank"
                    >
                      Google Analytics for Firebase
                    </a>
                  </p>
                  <h4>Log Data</h4>
                  <p style={{ marginBottom: "1.5rem" }}>
                    I want to inform you that whenever you use my Service, in a
                    case of an error in the app I collect data and information
                    (through third party products) on your phone called Log
                    Data. This Log Data may include information such as your
                    device Internet Protocol (“IP”) address, device name,
                    operating system version, the configuration of the app when
                    utilizing my Service, the time and date of your use of the
                    Service, and other statistics.
                  </p>
                  <h4>Cookies</h4>
                  <p style={{ marginBottom: "1.5rem" }}>
                    Cookies are files with a small amount of data that are
                    commonly used as anonymous unique identifiers. These are
                    sent to your browser from the websites that you visit and
                    are stored on your device's internal memory. This Service
                    does not use these “cookies” explicitly. However, the app
                    may use third party code and libraries that use “cookies” to
                    collect information and improve their services. You have the
                    option to either accept or refuse these cookies and know
                    when a cookie is being sent to your device. If you choose to
                    refuse our cookies, you may not be able to use some portions
                    of this Service.
                  </p>
                  <h4>Service Providers</h4>
                  <p style={{ marginBottom: "1.5rem" }}>
                    I may employ third-party companies and individuals due to
                    the following reasons:
                    <ul>
                      <il style={{ display: "block" }}>
                        {" "}
                        - To facilitate our Service.
                      </il>
                      <il style={{ display: "block" }}>
                        {" "}
                        - To provide the Service on our behalf.
                      </il>
                      <il style={{ display: "block" }}>
                        {" "}
                        - To perform Service-related services.
                      </il>
                      <il style={{ display: "block" }}>
                        {" "}
                        - To assist us in analyzing how our Service is used.
                      </il>
                    </ul>
                    I want to inform users of this Service that these third
                    parties have access to your Personal Information. The reason
                    is to perform the tasks assigned to them on our behalf.
                    However, they are obligated not to disclose or use the
                    information for any other purpose.
                  </p>
                  <h4>Security</h4>
                  <p style={{ marginBottom: "1.5rem" }}>
                    I value your trust in providing us your Personal
                    Information, thus we are striving to use commercially
                    acceptable means of protecting it. But remember that no
                    method of transmission over the internet, or method of
                    electronic storage is 100% secure and reliable, and I cannot
                    guarantee its absolute security.
                  </p>
                  <h4>Links to Other Sites</h4>
                  <p style={{ marginBottom: "1.5rem" }}>
                    This Service may contain links to other sites. If you click
                    on a third-party link, you will be directed to that site.
                    Note that these external sites are not operated by me.
                    Therefore, I strongly advise you to review the Privacy
                    Policy of these websites. I have no control over and assume
                    no responsibility for the content, privacy policies, or
                    practices of any third-party sites or services.
                  </p>
                  <h4>Children’s Privacy</h4>
                  <p style={{ marginBottom: "1.5rem" }}>
                    These Services do not address anyone under the age of 13. I
                    do not knowingly collect personally identifiable information
                    from children under 13\. In the case I discover that a child
                    under 13 has provided me with personal information, I
                    immediately delete this from our servers. If you are a
                    parent or guardian and you are aware that your child has
                    provided us with personal information, please contact me so
                    that I will be able to do necessary actions.
                  </p>
                  <h4>Changes to This Privacy Policy</h4>
                  <p style={{ marginBottom: "1.5rem" }}>
                    I may update our Privacy Policy from time to time. Thus, you
                    are advised to review this page periodically for any
                    changes. I will notify you of any changes by posting the new
                    Privacy Policy on this page. This policy is effective as of
                    2020-06-08
                  </p>
                  <h4>Contact Us</h4>
                  <p style={{ marginBottom: "1.5rem" }}>
                    If you have any questions or suggestions about my Terms and
                    Conditions, do not hesitate to contact me at <br />
                    <a href="mailto:Info.requestak@gmail.com">
                      Info.requestak@gmail.com
                    </a>
                  </p>

                  <p style={{ marginBottom: "1.5rem" }}>
                    This Terms and Conditions page was generated by [App Privacy
                    Policy Generator]
                  </p>
                  {/* <ol type="1">
                    <li>
                      Purchased lessons and products or services are
                      non-refundable.
                    </li>
                    <li>
                      Educlub purchased videos of lessons are valid for 1 or
                      more days from date of actual purchasing( depends on the
                      video).
                    </li>
                    <li>
                      Distribution of Educlub content is strictly prohibited and
                      may result in the cancellation of your subscription.
                    </li>
                    <li>
                      Accounts are for personal use only and are not
                      transferable.
                    </li>
                    <li>
                      Sharing an account with another person is not permitted.
                    </li>
                    <li>
                      You may access your account from a maximum of two devices.
                    </li>
                    <li>
                      Educlub does not endorse and is not responsible for, the
                      accuracy or reliability of any opinion, advice, or
                      statement made through the site by any other party.
                    </li>
                    <li>
                      Educlub reserves the right to withdraw registration and
                      subscriptions and the complete site if necessary.
                    </li>
                    <li>
                      Except as required by law, Educlub will maintain the
                      confidentiality of all user communications, which contain
                      personal user information and are transmitted directly to
                      Educlub.
                    </li>
                    <li>
                      Educlub is not responsible for the content available on
                      any other Internet sites linked to the site. Access to
                      other Internet sites linked to the site is at your own
                      risk.
                    </li>
                    <li>
                      Educlub is under no obligation to review any messages,
                      information, or content (“Postings”) posted on the site by
                      users and assumes no responsibility or liability relating
                      to any such postings.
                    </li>
                    <li>
                      If you breach any term of this agreement, Educlub may, at
                      its sole discretion, terminate this agreement, your access
                      to the site, and its provision of services to you without
                      refund.{" "}
                    </li>
                    <li>
                      Educlub reserves the right to seek all remedies available
                      by law and in equity for such breaches.
                    </li>
                    <li>
                      By using our platform, you acknowledge that you have read
                      and understand these terms and conditions and agree to be
                      bound by them. Please do not use our platform if you do
                      not agree to these terms. If you have any questions or
                      concerns, please don’t hesitate to contact us for
                      assistance. Cookies Terms
                    </li>
                    <li>
                      Educlub may opt-in to saving your name, email address and
                      website in cookies. These are for your convenience so that
                      you do not have to fill in your details again when you
                      leave another comment. These cookies will last for one
                      year.
                    </li>
                    <li>
                      If you visit our login page, we will set a temporary
                      cookie to determine if your browser accepts cookies. This
                      cookie contains no personal data and is discarded when you
                      close your browser.
                    </li>
                    <li>
                      When you log in, we will also set up several cookies to
                      save your login information and your screen display
                      choices.{" "}
                    </li>
                    <li>
                      Login cookies last for two days, and screen options
                      cookies last for a year. If you select “Remember Me”, your
                      login will persist for two weeks. If you log out of your
                      account, the login cookies will be removed.
                    </li>
                    <li>
                      If you edit or publish an article, an additional cookie
                      will be saved in your browser. This cookie includes no
                      personal data and simply indicates the post ID of the
                      article you just edited. It expires after 1 day.Embedded
                      Content From Other Websites
                    </li>
                    <li>
                      Articles on this site may include embedded content (e.g.
                      videos, images, articles, etc.). Embedded content from
                      other websites behaves in the exact same way as if the
                      visitor has visited the other website.
                    </li>
                    <li>
                      These websites may collect data about you, use cookies,
                      embed additional third-party tracking, and monitor your
                      interaction with that embedded content, including tracking
                      your interaction with the embedded content if you have an
                      account and are logged in to that website. Media
                    </li>
                    <li>
                      If you upload images to the website, you should avoid
                      uploading images with embedded location data (EXIF GPS)
                      included. Visitors to the website can download and extract
                      any location data from images on the website. What Rights
                      You Have Over Your Data
                    </li>
                    <li>
                      If you have an account on this site, you can request to
                      receive an exported file of the personal data we hold
                      about you, including any data you have provided to us. You
                      can also request that we erase any personal data we hold
                      about you. This does not include any data we are obliged
                      to keep for administrative, legal, or security purposes.
                      How Long We Retain Your Data
                    </li>
                    <li>
                      For users that register on our website (if any), we store
                      the personal information they provide in their user
                      profile. All users can see, edit, or delete their personal
                      information at any time (except they cannot change their
                      username). Website administrators can also see and edit
                      that information. Where Your Data Is Sent
                    </li>
                    <li>
                      Visitor postings may be checked through an automated spam
                      detection services. If you request a password reset, your
                      IP address will be included in the reset email.
                    </li>
                  </ol> */}
                  {/* <p>
                    Research for your next design project is done by a team of
                    industry experts. We help with research, data analysis, and
                    visualization. Our expertise covers many different fields
                    including UX Design, Brand Strategy, Content Writing, User
                    Experience Design and more.
                  </p> */}
                </div>
                {/* <div className="services__details-left-image mb-60">
                  <img src="assets/img/services_details-1.jpg" alt="" />
                  <div className="row mt-30">
                    <div className="col-sm-6 sm-mb-30">
                      <img
                        className="img__full"
                        src="assets/img/services_details-2.jpg"
                        alt=""
                      />
                    </div>
                    <div className="col-sm-6">
                      <img
                        className="img__full"
                        src="assets/img/services_details-3.jpg"
                        alt=""
                      />
                    </div>
                  </div>
                </div> */}
                {/* <div className="services__details-left-feedback">
                  <div className="row">
                    <div className="col-xl-6 xl-mb-30">
                      <div className="feedback__area-item">
                        <div className="feedback__area-item-quote">
                          <img src="assets/img/icon/quote.png" alt="" />
                        </div>
                        <div className="feedback__area-item-reviews">
                          <h5>Good :</h5>
                          <ul>
                            <li>
                              <Link to="">
                                <i className="fas fa-star"></i>
                              </Link>
                            </li>
                            <li>
                              <Link to="">
                                <i className="fas fa-star"></i>
                              </Link>
                            </li>
                            <li>
                              <Link to="">
                                <i className="fas fa-star"></i>
                              </Link>
                            </li>
                            <li>
                              <Link to="">
                                <i className="fas fa-star"></i>
                              </Link>
                            </li>
                            <li>
                              <Link to="">
                                <i className="fas fa-star"></i>
                              </Link>
                            </li>
                          </ul>
                        </div>
                        <div className="feedback__area-item-content">
                          <p>
                            pellentesque in dolor vel malesuada. Donec finibus
                            libero odio, ac iaculis metus mattis quis.
                          </p>
                        </div>
                        <div className="feedback__area-item-bottom">
                          <div className="feedback__area-item-bottom-avatar">
                            <img
                              src="assets/img/avatar/feedback-1.jpg"
                              alt=""
                            />
                          </div>
                          <div className="feedback__area-item-bottom-title">
                            <h5>david bowie</h5>
                            <span>UX Designer</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-6 lg-mb-30">
                      <div className="feedback__area-item">
                        <div className="feedback__area-item-quote">
                          <img src="assets/img/icon/quote.png" alt="" />
                        </div>
                        <div className="feedback__area-item-reviews">
                          <h5>Good :</h5>
                          <ul>
                            <li>
                              <Link to="">
                                <i className="fas fa-star"></i>
                              </Link>
                            </li>
                            <li>
                              <Link to="">
                                <i className="fas fa-star"></i>
                              </Link>
                            </li>
                            <li>
                              <Link to="">
                                <i className="fas fa-star"></i>
                              </Link>
                            </li>
                            <li>
                              <Link to="">
                                <i className="fas fa-star"></i>
                              </Link>
                            </li>
                            <li>
                              <Link to="">
                                <i className="fas fa-star"></i>
                              </Link>
                            </li>
                          </ul>
                        </div>
                        <div className="feedback__area-item-content">
                          <p>
                            pellentesque in dolor vel malesuada. Donec finibus
                            libero odio, ac iaculis metus mattis quis.
                          </p>
                        </div>
                        <div className="feedback__area-item-bottom">
                          <div className="feedback__area-item-bottom-avatar">
                            <img
                              src="assets/img/avatar/feedback-2.jpg"
                              alt=""
                            />
                          </div>
                          <div className="feedback__area-item-bottom-title">
                            <h5>michel aoun</h5>
                            <span>Marketing</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
            {/* <div className="col-xl-4 col-lg-4">
              <div className="all__sidebar ml-25 xl-ml-0">
                <div className="all__sidebar-item services">
                  <h4>Our Services</h4>
                  <div className="all__sidebar-item-category">
                    <ul>
                      <li>
                        <Link to="">
                          <i className="far fa-angle-double-right"></i>Design
                          Research<span>(08)</span>
                        </Link>
                      </li>
                      <li>
                        <Link to="">
                          <i className="far fa-angle-double-right"></i>
                          Development<span>(06)</span>
                        </Link>
                      </li>
                      <li>
                        <Link to="">
                          <i className="far fa-angle-double-right"></i>Digital
                          Marketing<span>(05)</span>
                        </Link>
                      </li>
                      <li>
                        <Link to="">
                          <i className="far fa-angle-double-right"></i>Branding
                          <span>(09)</span>
                        </Link>
                      </li>
                      <li>
                        <Link to="">
                          <i className="far fa-angle-double-right"></i>Market
                          Research<span>(03)</span>
                        </Link>
                      </li>
                      <li>
                        <Link to="">
                          <i className="far fa-angle-double-right"></i>SEO
                          marketing<span>(02)</span>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div
                  className="all__sidebar-item-help"
                  style={{ backgroundImage: `url('assets/img/details-3.jpg')` }}
                >
                  <h4>Need Any Help?</h4>
                  <div className="all__sidebar-item-help-contact">
                    <div className="all__sidebar-item-help-contact-icon">
                      <i className="fal fa-phone-alt"></i>
                    </div>
                    <div className="all__sidebar-item-help-contact-content">
                      <span>Quick Help</span>
                      <h6>
                        <a href="tel:+123(458)896895">01552710828</a>
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
      <FooterOne></FooterOne>
    </>
  );
};

export default Privacy;
